/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import {getServiceT008, putServiceT008} from '../../core/prestation/request'
import {useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import {useParams} from 'react-router-dom'
import {useAuth} from '../../../../auth'
import * as lodash from 'lodash'
import {CenterHelp} from '../../../../../common/components/CenterHelp/CenterHelp'
import {ListeServiceStatus} from '../../core/prestation/model'
import clsx from 'clsx'
import {Modal} from 'react-bootstrap'
import {useThemeMode} from '../../../../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {RadioButton} from '../../../../../common/components/RadioButton/RadioButton'

type Props = {
  isVisible7: boolean
  onSavedForm?: (saved: boolean) => void
  onDetectChangeForm?: (isThereChange: boolean) => void
  loadListServiceStatus?: Function
  t008?: ListeServiceStatus
}

type Step = {
  Id?: number
  Title?: string
  Height?: string
}

type T008 = {
  Assembly?: boolean | null
  AssemblyStepsNumber?: number | null | any
  AssemblySteps: Step[] | null
  Disassembly?: boolean | null
  DisassemblyStepsNumber?: number | null | any
  DisassemblySteps: Step[] | null
}

const ToggleButtonForm8: FC<Props> = ({
  isVisible7,
  onSavedForm,
  onDetectChangeForm,
  loadListServiceStatus,
  t008,
}) => {
  const {setAuthMessage, logout} = useAuth()
  const intl = useIntl()
  const {pGuid} = useParams()
  const projectData = useSelector((state: any) => state?.projectData)
  const Submitted = useSelector((state: any) => state?.projectStatus?.Submitted)
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const {mode} = useThemeMode()
  const [loading] = useState<boolean>(false)
  const [serviceT008, setServiceT008] = useState<T008>({
    Assembly: null,
    AssemblyStepsNumber: 0,
    AssemblySteps: [],
    Disassembly: null,
    DisassemblyStepsNumber: 0,
    DisassemblySteps: [],
  })
  const [t1init, setT1init] = useState<T008>({
    Assembly: null,
    AssemblyStepsNumber: 0,
    AssemblySteps: [],
    Disassembly: null,
    DisassemblyStepsNumber: 0,
    DisassemblySteps: [],
  })
  const [, setIsDebounce] = useState<boolean>(false)
  const onCancelReset = () => {
    setShowCancel(false)
  }
  const onConfirmCancel = async () => {
    if (pGuid) {
      await loadDataServiceT008()
      setShowCancel(false)
    } else {
      setServiceT008({...t1init})
      await loadDataServiceT008()
      setShowCancel(false)
    }
  }

  const reInitAssembly = (Assembly: boolean = false) => {
    setServiceT008((prev) => ({
      ...(prev as T008),
      Assembly: Assembly,
      AssemblyStepsNumber: 1,
      AssemblySteps: Array(1).fill({
        Id: null,
        Title: '',
        Height: '',
      }),
    }))
  }
  const reInitDisAssembly = (Disassembly: boolean = false) => {
    setServiceT008((prev) => ({
      ...(prev as T008),
      Disassembly: Disassembly,
      DisassemblyStepsNumber: 1,
      DisassemblySteps: Array(1).fill({
        Id: null,
        Title: '',
        Height: '',
      }),
    }))
  }
  const assemblyStepsNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value)
    if (event.target.value === '') {
      //reInitAssembly()
      setServiceT008((prevState) => ({...prevState, AssemblyStepsNumber: ''}))
    } else if (value > 0 && Number.isInteger(value)) {
      if ((serviceT008?.AssemblySteps?.length || 0) < value) {
        const assemblyStep: Step[] = Array.isArray(serviceT008.AssemblySteps)
          ? [...serviceT008.AssemblySteps]
          : []
        const data = assemblyStep.pop()
        setServiceT008((prevState) => {
          return {
            ...(prevState as T008),
            AssemblyStepsNumber: value,
            AssemblySteps: serviceT008?.AssemblySteps
              ? [
                  ...serviceT008?.AssemblySteps,
                  ...Array(
                    value -
                      (prevState?.AssemblySteps?.length ? prevState?.AssemblySteps?.length : 0)
                  )
                    .fill({
                      Id: null,
                      Title: '',
                      Height: '',
                    })
                    .map((assemblies, index) => {
                      return {
                        ...assemblies,
                        Id: (data?.Id || 0) + (index + 1),
                      }
                    }),
                ]
              : Array(value)
                  .fill({
                    Id: null,
                    Title: '',
                    Height: '',
                  })
                  .map((assemblies, index) => ({
                    ...assemblies,
                    Id: index,
                  })),
          }
        })
      }
      if (serviceT008?.AssemblySteps?.length && serviceT008?.AssemblySteps?.length > value) {
        setServiceT008((prevState) => {
          return {
            ...(prevState as T008),
            AssemblyStepsNumber: value,
            AssemblySteps:
              prevState && Array.isArray(prevState?.AssemblySteps)
                ? prevState?.AssemblySteps?.slice(0, value)
                : [],
          }
        })
      }
    }
  }
  const assemblyStepChangeItem = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>,
    isParseNumber: boolean = false
  ) => {
    const _newAssemblySteps = serviceT008?.AssemblySteps ? [...serviceT008?.AssemblySteps] : []
    if (_newAssemblySteps.length < 1) return
    _newAssemblySteps[index] = {
      ..._newAssemblySteps[index],
      [event.target.name]: isParseNumber ? Number(event.target.value) : event.target.value,
      Id: index + 1,
    }
    setServiceT008((prevState) => {
      return {
        ...(prevState as T008),
        AssemblySteps: _newAssemblySteps,
      }
    })
  }

  const disassemblyStepsNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(event.target.value)
    if (event.target.value === '') {
      //reInitAssembly()
      setServiceT008((prevState) => ({...prevState, DisassemblyStepsNumber: ''}))
    } else if (value > 0 && Number.isInteger(value)) {
      const disassemblyStep: Step[] = Array.isArray(serviceT008.DisassemblySteps)
        ? [...serviceT008.DisassemblySteps]
        : []
      const data = disassemblyStep.pop()
      if ((serviceT008?.DisassemblySteps?.length || 0) < value) {
        setServiceT008((prevState) => {
          return {
            ...(prevState as T008),
            DisassemblyStepsNumber: value,
            DisassemblySteps: serviceT008?.DisassemblySteps
              ? [
                  ...serviceT008?.DisassemblySteps,
                  ...Array(value - (prevState?.DisassemblySteps?.length ?? 0))
                    .fill({
                      Id: null,
                      Title: '',
                      Height: '',
                    })
                    .map((disassemblies, index) => {
                      return {
                        ...disassemblies,
                        Id: (data?.Id || 0) + (index + 1),
                      }
                    }),
                ]
              : Array(value)
                  .fill({
                    Id: null,
                    Title: '',
                    Height: '',
                  })
                  .map((disassemblies, index) => {
                    return {
                      ...disassemblies,
                      Id: index + 1,
                    }
                  }),
          }
        })
      }
      if (serviceT008?.DisassemblySteps?.length && serviceT008?.DisassemblySteps?.length > value) {
        setServiceT008((prevState) => {
          return {
            ...(prevState as T008),
            DisassemblyStepsNumber: value,
            DisassemblySteps:
              prevState && Array.isArray(prevState?.DisassemblySteps)
                ? prevState?.DisassemblySteps?.slice(0, value)
                : [],
          }
        })
      }
    }
  }

  const disassemblyStepChangeItem = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>,
    isParseNumber: boolean = false
  ) => {
    const _newDisAssemblySteps = serviceT008?.DisassemblySteps
      ? [...serviceT008?.DisassemblySteps]
      : []
    if (_newDisAssemblySteps.length < 1) return
    _newDisAssemblySteps[index] = {
      ..._newDisAssemblySteps[index],
      [event.target.name]: isParseNumber ? Number(event.target.value) : event.target.value,
      Id: index + 1,
    }
    setServiceT008((prevState) => {
      return {
        ...(prevState as T008),
        DisassemblySteps: _newDisAssemblySteps,
      }
    })
  }
  const handleBorder1 = () => {
    reInitAssembly(true)
    //setActiveBorder1(BorderBloc1.Border1)
    setServiceT008((prevState) => {
      return {
        ...(prevState as T008),
        Assembly: true,
      }
    })
  }

  const handleBorder2 = () => {
    //setActiveBorder1(BorderBloc1.Border2)
    setServiceT008((prevState) => {
      return {
        ...(prevState as T008),
        Assembly: false,
        AssemblyStepsNumber: !prevState.AssemblyStepsNumber ? 1 : prevState.AssemblyStepsNumber,
        AssemblySteps: Array(1).fill({
          Id: 1,
          Title: '',
          Height: '',
        }),
      }
    })
  }
  const handleBorder3 = () => {
    reInitDisAssembly(true)
    //setActiveBorder2(BorderBloc2.Border3)
  }
  const handleBorder4 = () => {
    setServiceT008((prevState) => {
      return {
        ...(prevState as T008),
        Disassembly: false,
        DisassemblyStepsNumber: !prevState.DisassemblyStepsNumber
          ? 1
          : prevState.DisassemblyStepsNumber,
        DisassemblySteps: Array(1).fill({
          Id: 1,
          Title: '',
          Height: '',
        }),
      }
    })
  }

  const isDisabled = useMemo(() => {
    return lodash.isEqual(serviceT008, t1init)
  }, [serviceT008, t1init])

  const disabledSubmit = useMemo(() => {
    return (
      isDisabled ||
      serviceT008 == null ||
      serviceT008.Assembly == null ||
      serviceT008.Disassembly == null ||
      !serviceT008.AssemblyStepsNumber ||
      !serviceT008.DisassemblyStepsNumber ||
      serviceT008.AssemblyStepsNumber === '' ||
      serviceT008.DisassemblyStepsNumber === ''
    )
  }, [isDisabled, serviceT008])

  useEffect(() => {
    if (onDetectChangeForm) {
      onDetectChangeForm(isDisabled)
    }
  }, [isDisabled])
  const loadDataServiceT008 = async () => {
    const response = await getServiceT008(
      pGuid || projectData?.tab1?.data?.Guid || '',
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    if (response?.data && response?.data?.data) {
      setServiceT008(response?.data?.data)
      setT1init(response?.data?.data)
      setIsDebounce(true)
    }
  }

  const onPutT008 = async () => {
    const response = await putServiceT008(
      {
        ProjectGuid: pGuid || projectData?.tab1?.data?.Guid || '',
        ...serviceT008,
      },
      (message: string) => {
        setAuthMessage(message)
        logout()
      },
      ({Message, MessageType, Toast, ToastType}) => {
        if (Message && MessageType === 'Success') {
          //
        } else if (Message && MessageType === 'Error') {
          //
        } else if (Toast && ToastType === 'Success') {
          toast(Toast, {type: 'success'})
        } else if (Toast && ToastType === 'Error') {
          toast(Toast, {type: 'error'})
        }
      }
    )
    if (response.data.Status.Success) {
      await loadDataServiceT008()
      if (loadListServiceStatus) {
        loadListServiceStatus()
      }
    }
  }
  useEffect(() => {
    loadDataServiceT008()
  }, [])
  return (
    <div>
      {isVisible7 && (
        <div className='d-flex flex-column'>
          <div className='p-5 mt-8'>
            <div className='d-flex justify-content-between my-4 '>
              <div
                className='gap-5 d-flex justify-content-xl-between  flex-xl-row flex-lg-column flex-md-column flex-sm-column flex-column'
                style={{flex: 0.9}}
              >
                <div style={{flex: 0.6}}>
                  <label className='fs-4 text-gray-700 me-2 '>
                    {intl.formatMessage({id: 'SINGLE_PHASE'})}
                  </label>
                  ({' '}
                  <i className='fa fa-star-of-life text-danger' style={{fontSize: 10, top: -5}}></i>{' '}
                  )
                </div>
                <div className='d-flex gap-10' style={{flex: 0.4}}>
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'YES'})}
                    checked={serviceT008?.Assembly === true}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      if (t008?.Enabled) handleBorder1()
                      else {
                        toast.error('Lecture seul', {
                          position: 'top-center',
                        })
                      }
                    }}
                  />
                  <RadioButton
                    classNameContainer='d-flex gap-3 align-items-center'
                    label={intl.formatMessage({id: 'NO'})}
                    checked={serviceT008?.Assembly === false}
                    classNameCheckedActive=''
                    classNameCheckedInactive=''
                    classNameDefaultLabel=''
                    handleClick={() => {
                      if (t008?.Enabled) handleBorder2()
                      else {
                        toast.error('Lecture seul', {
                          position: 'top-center',
                        })
                      }
                    }}
                  />
                  {/*   <div className='d-flex gap-3 align-items-center'>
                    <div
                      className='bg-light'
                      style={{
                        border:
                          serviceT008?.Assembly === true
                            ? '6px solid #e74c3c'
                            : '1px solid gray',
                        borderRadius: 100,
                        width: 20,
                        height: 20,
                      }}
                      onClick={() => {
                       if(t008?.Enabled) handleBorder1()
                       else {
                            toast.error("Lecture seul", {
                              position: "top-center",
                          })
                       }
                      }}
                    ></div>
                    <label>{intl.formatMessage({id: 'YES'})}</label>
                  </div> */}
                  {/*  <div className='d-flex gap-3 align-items-center'>
                    <div
                      className='bg-light'
                      style={{
                        border:
                            serviceT008?.Assembly === false
                            ? '6px solid #e74c3c'
                            : '1px solid gray',
                        borderRadius: 100,
                        width: 20,
                        height: 20,
                      }}
                      onClick={() =>
                        {
                          if(t008?.Enabled) handleBorder2()
                          else {
                            toast.error("Lecture seul", {
                              position: "top-center",
                           })
                          }
                      }}
                    ></div>
                    <label>{intl.formatMessage({id: 'NO'})}</label>
                  </div> */}
                </div>
              </div>
              <div style={{flex: 0.1}} className='d-flex justify-content-end'>
                {/*<CenterHelp />*/}
              </div>
            </div>

            {serviceT008?.Assembly === false && (
              <div>
                <div className='gap-1 justify-content-xl-between d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row flex-1 my-5'>
                  <div style={{flex: 0.53}} className='mb-5 mb-sm-5 mb-md-5 mb-lg-5'>
                    <label className='fs-4 text-gray-700 me-2 '>
                      {intl.formatMessage({id: 'NUMBER_OF_PHASE'})}
                    </label>
                    ({' '}
                    <i
                      className='fa fa-star-of-life text-danger'
                      style={{fontSize: 10, top: -5}}
                    ></i>{' '}
                    )
                  </div>
                  <div
                    style={{flex: 0.47, marginLeft: 17}}
                    className='gap-5 justify-content-xl-between justify-content-lg-between  d-xl-flex d-lg-flex flex-md-column flex-sm-column flex-column flex-xl-row flex-lg-row'
                  >
                    <div className='d-flex mb-3 mb-sm-4'>
                      <input
                        type='number'
                        //min={1}
                        disabled={!t008?.Enabled || Submitted}
                        value={serviceT008?.AssemblyStepsNumber || ''}
                        onChange={assemblyStepsNumberChange}
                        className='form-control form-control-solid w-100px'
                      />
                    </div>
                  </div>
                </div>

                <div className='gap-1 justify-content-xl-between d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row flex-1 my-5'>
                  <div style={{flex: 0.53}} className='mb-5 mb-sm-5 mb-md-5 mb-lg-5'>
                    <label className='fs-4 text-gray-700 me-2 '>
                      {intl.formatMessage({id: 'DETAILS_OF_PHASES'})}
                    </label>
                  </div>
                  <div style={{flex: 0.47, marginLeft: 17}}>
                    <div className='gap-5 justify-content-xl-between justify-content-lg-between d-xl-flex d-lg-flex flex-md-column flex-sm-column flex-column flex-xl-row flex-lg-row'>
                      <div className='mb-3 mb-sm-4'>
                        <span></span>
                      </div>
                      <div className='mb-3 mb-sm-4'>
                        <span>Niveaux concernés</span>
                      </div>
                      <div className='mb-3 mb-sm-4'>
                        <span>Hauteur traitée (m)</span>
                      </div>
                    </div>

                    {Array.isArray(serviceT008?.AssemblySteps) &&
                      serviceT008?.AssemblySteps.map((assembly, index) => (
                        <div
                          key={assembly.Id ?? index}
                          className='gap-5 justify-content-xl-between justify-content-lg-between  d-xl-flex d-lg-flex flex-md-column flex-sm-column flex-column flex-xl-row flex-lg-row'
                        >
                          <div className={'mt-3 mt-sm-4'}>{index + 1}</div>
                          <div className='mb-3 mb-sm-4'>
                            <input
                              type='text'
                              value={assembly?.Title || ''}
                              name='Title'
                              disabled={!t008?.Enabled || Submitted}
                              onChange={(event) => assemblyStepChangeItem(index, event, false)}
                              className='form-control form-control-solid w-100%'
                            />
                          </div>
                          <div className='mb-3 mb-sm-4'>
                            <input
                              type='number'
                              value={assembly?.Height || ''}
                              min={0}
                              disabled={!t008?.Enabled || Submitted}
                              name='Height'
                              onChange={(event) => assemblyStepChangeItem(index, event, true)}
                              className='form-control form-control-solid w-100'
                            />
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            )}

            <div className=' d-flex justify-content-xl-between  flex-xl-row flex-lg-column flex-md-column flex-sm-column flex-column my-4'>
              <div style={{flex: 0.55}}>
                <label className='fs-4 text-gray-700 '>
                  {intl.formatMessage({id: 'SINGLE_PHASE_DISASSEMBLY'})}
                </label>
                ( <i className='fa fa-star-of-life text-danger' style={{fontSize: 10, top: -5}}></i>{' '}
                )
              </div>
              <div className='d-flex gap-10' style={{flex: 0.45}}>
                <RadioButton
                  classNameContainer='d-flex gap-3 align-items-center'
                  label={intl.formatMessage({id: 'YES'})}
                  checked={serviceT008?.Disassembly === true}
                  classNameCheckedActive=''
                  classNameCheckedInactive=''
                  classNameDefaultLabel=''
                  handleClick={() => {
                    if (t008?.Enabled) handleBorder3()
                    else {
                      toast.error('Lecture seul', {
                        position: 'top-center',
                      })
                    }
                  }}
                />
                <RadioButton
                  classNameContainer='d-flex gap-3 align-items-center'
                  label={intl.formatMessage({id: 'NO'})}
                  checked={serviceT008?.Disassembly === false}
                  classNameCheckedActive=''
                  classNameCheckedInactive=''
                  classNameDefaultLabel=''
                  handleClick={() => {
                    if (t008?.Enabled) handleBorder4()
                    else {
                      toast.error('Lecture seul', {
                        position: 'top-center',
                      })
                    }
                  }}
                />
                {/*  <div className='d-flex gap-3 align-items-center'>
                  <div
                    className='bg-light'
                    style={{
                      border:
                        serviceT008.Disassembly === true
                          ? '6px solid #e74c3c'
                          : '1px solid gray',
                      borderRadius: 100,
                      width: 20,
                      height: 20,
                    }}
                    onClick={() =>
                      {
                        if(t008?.Enabled) handleBorder3()
                        else {
                          toast.error("Lecture seul", {
                            position: "top-center",
                         })
                        }
                    }}
                  ></div>
                  <label>{intl.formatMessage({id: 'YES'})}</label>
                </div> */}
                {/*  <div className='d-flex gap-3 align-items-center'>
                  <div
                    className='bg-light'
                    style={{
                      border:
                          serviceT008.Disassembly === false
                          ? '6px solid #e74c3c'
                          : '1px solid gray',
                      borderRadius: 100,
                      width: 20,
                      height: 20,
                    }}
                    onClick={() =>
                      {
                        if(t008?.Enabled) handleBorder4()
                        else {
                          toast.error("Lecture seul", {
                            position: "top-center",
                         })
                        }
                    }}
                  ></div>
                  <label>{intl.formatMessage({id: 'NO'})}</label>
                </div> */}
              </div>
            </div>

            {serviceT008.Disassembly === false && (
              <>
                <div className='gap-1 justify-content-xl-between d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row flex-1 my-5'>
                  <div style={{flex: 0.53}} className='mb-5 mb-sm-5 mb-md-5 mb-lg-5'>
                    <label className='fs-4 text-gray-700 me-2 '>
                      {intl.formatMessage({id: 'NUMBER_OF_PHASE_DISASSEMBLY'})}
                    </label>
                    ({' '}
                    <i
                      className='fa fa-star-of-life text-danger'
                      style={{fontSize: 10, top: -5}}
                    ></i>{' '}
                    )
                  </div>
                  <div
                    style={{flex: 0.47, marginLeft: 17}}
                    className='gap-5 justify-content-xl-between justify-content-lg-between  d-xl-flex d-lg-flex flex-md-column flex-sm-column flex-column flex-xl-row flex-lg-row'
                  >
                    <div className='d-flex mb-3 mb-sm-4'>
                      <input
                        type='number'
                        min={1}
                        className='form-control form-control-solid w-100px'
                        onChange={disassemblyStepsNumberChange}
                        disabled={!t008?.Enabled || Submitted}
                        value={serviceT008?.DisassemblyStepsNumber ?? 1}
                      />
                    </div>
                  </div>
                </div>

                <div className='gap-1 justify-content-xl-between d-xl-flex flex-lg-column flex-lg-column flex-md-column flex-sm-column flex-column flex-xl-row flex-1 my-5'>
                  <div style={{flex: 0.5}} className='mb-5 mb-sm-5 mb-md-5 mb-lg-5'>
                    <label className='fs-4 text-gray-700 me-2 '>
                      {intl.formatMessage({id: 'DETAILS_OF_PHASES_DISASSEMBLY'})}
                    </label>
                  </div>
                  <div style={{flex: 0.47, marginLeft: 17}}>
                    <div className='d-flex justify-content-end'>
                      <span>Hauteur traitée (m)</span>
                    </div>
                    {Array.isArray(serviceT008.DisassemblySteps) &&
                      serviceT008.DisassemblySteps.map((disassembly, index) => (
                        <div
                          key={disassembly?.Id ?? index}
                          className='gap-5 justify-content-xl-between justify-content-lg-between  d-xl-flex d-lg-flex flex-md-column flex-sm-column flex-column flex-xl-row flex-lg-row'
                        >
                          <div className={'mt-3 mt-sm-4'}>{index + 1}</div>
                          <div className='d-flex mb-3 mb-sm-4'>
                            <input
                              type='text'
                              value={disassembly?.Title || ''}
                              name='Title'
                              disabled={!t008?.Enabled || Submitted}
                              onChange={(event) => disassemblyStepChangeItem(index, event, false)}
                              className='form-control form-control-solid w-100%'
                            />
                          </div>
                          <div className='mb-3'>
                            <input
                              type='number'
                              className='form-control form-control-solid w-100'
                              value={disassembly?.Height || ''}
                              min={0}
                              disabled={!t008?.Enabled || Submitted}
                              name='Height'
                              onChange={(event) => disassemblyStepChangeItem(index, event, true)}
                            />
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </>
            )}

            {!Submitted && (
              <div className='d-flex gap-5 justify-content-end my-5'>
                <button
                  style={{cursor: isDisabled ? 'not-allowed' : 'pointer'}}
                  className='btn btn-dark'
                  disabled={isDisabled}
                  onClick={() => {
                    //setServiceT008(t1init)
                    setShowCancel(true)
                  }}
                >
                  {intl.formatMessage({id: 'RESET'})}
                  <i className='fa-solid fa-eraser fs-4 ms-2'></i>
                </button>
                <button
                  className={clsx('btn btn-danger')}
                  style={disabledSubmit ? {cursor: 'not-allowed'} : undefined}
                  disabled={disabledSubmit}
                  onClick={onPutT008}
                >
                  {intl.formatMessage({id: 'SAVE'})}
                  <i className='fa-regular fa-floppy-disk fs-4 ms-2'></i>
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      <Modal show={showCancel} centered>
        <div className='text-center p-5 w-100' data-bs-theme={mode}>
          <div
            className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
            data-bs-theme={mode}
          >
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-start py-3'}>
              <div>{intl.formatMessage({id: 'RESET_CONFIRM_MESSAGE'})}</div>
            </div>
            <div className='d-flex align-items-center justify-content-evenly'>
              <button className={'btn btn-secondary'} onClick={onCancelReset}>
                {intl.formatMessage({id: 'NO'})}
              </button>
              {!loading && (
                <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                  {intl.formatMessage({id: 'YES'})}
                </button>
              )}
              {loading && (
                <button className={'btn btn-primary'} onClick={() => {}}>
                  {'...'}
                </button>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ToggleButtonForm8
